<!-- //NOSONAR --><section
  class="inner"
  *ngIf="facetList$ | async as facets"
  [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate"
  [cxFocus]="isDialog ? dialogFocusConfig : {}"
  (esc)="close($event)"
  (click)="block($event)"
  onkeydown="this.blur()"
  role="button"
  tabIndex="-1"
>
  <div class="list-header">
    <h4>
      {{ 'productList.filterBy.label' | cxTranslate }}
    </h4>
    <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
      <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
    </button>
  </div>

  <cx-facet
    *ngFor="let facet of facets"
    #facetRef
    [facet]="facet"
    [class.expanded]="isExpanded(facet) | async"
    [class.collapsed]="isCollapsed(facet) | async"
    attr.aria-label="{{
      'productFacetNavigation.ariaLabelItemsAvailable'
        | cxTranslate
          : {
              name: facet.name,
              count: facet?.values?.length
            }
    }}"
  ></cx-facet>
</section>
